module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.467b1f56.png";